import React from 'react'
import moment from 'moment'
import strip from 'striptags'
import md5 from 'blueimp-md5'
import petrovich from 'petrovich'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Textarea from 'react-textarea-autosize'
import { omit, pick, isEmpty, isNil } from 'lodash'
import { compose, lifecycle, withState, withHandlers } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'

import Loader from '../Loader'
import OverlayLoader from '../OverlayLoader'

import { fetchingState } from './../../helpers/hocs.js'
import { uploadImage, sendReport } from './../../store/reducers/profile/report'

const getNames = (persons) => {
  const lastIndex = persons.length - 1
  let result = persons.reduce((result, { name, gender }, index) => {
    name = name.split(' ')
    const formatted = petrovich({ gender: gender || 'male', first: name[0], last: name[1] }, 'instrumental')
    result += `${formatted.first} ${formatted.last}${(index === lastIndex) ? '' : ((index >= (lastIndex - 1)) ? ' ' + (<FormattedMessage id='common.and' />) + ' ' : ', ')}`
    return result
  }, '')

  return result
}

const ReportForm = ({ upload, imagesState, images, imageRemove, lot, message, setMessage, submit, errors, success, fetching, intl }) => {
  if (!lot) return null

  return success ? <h1 className='modal__head Head'>
    <FormattedMessage id='profile_report.report_sent' />
  </h1>
    : (
      <div>
        <h1 className='modal__head Head'>
          <FormattedMessage id='profile_report.report_about' />
          {' '}
          {getNames(lot.persons)}
        </h1>
        <span className='modal__caption Text'>{moment(lot.closeDate).format('D MMMM')}</span>

        <OverlayLoader isOrange loading={fetching}>
          <div className='modal__form'>
            <div className='modal__textarea'>
              <Textarea
                className='Textarea'
                minRows={1}
                onChange={setMessage}
                value={message}
                placeholder={intl.formatMessage({id: 'profile_report.your_impressions'})}
              />
              {errors.message && <div className='Text'>{errors.message}</div>}
              {!isNil(success) && <div className='Text'><FormattedMessage id='profile_report.error' /></div>}
            </div>
            <button className='modal__submit' onClick={submit}><FormattedMessage id='profile_report.send' /></button>
          </div>

          <div className='modal__photos'>
            <label className='Button Button_white modal__photos-label'>
              <input className='modal__photos-field' type='file' multiple onChange={upload} />
              <FormattedMessage id='profile_report.add_photo' />
            </label>

            <div className='modal__photos-preview'>
              {Object.keys(imagesState).map(key => (
                <div className='modal__photos-preview-item' key={key}>
                  {(imagesState[key] < 100 || !images[key])
                    ? <Loader isLight />
                    : (
                      <div className='modal__photos-preview-img'>
                        <img src={images[key].url} alt={images[key].name} className='' />
                        <span className='modal__photos-preview-overlay Text' onClick={imageRemove.bind(this, key)}>
                          <span className='modal__photos-preview-overlay__after'>
                            {intl.formatMessage({id: 'profile_report.delete_photo'})}
                          </span>
                        </span>
                      </div>
                    )
                  }
                </div>
              ))}
            </div>
          </div>
        </OverlayLoader>
      </div>
    )
}

const mapStateToProps = state => ({ ...state.profile.report })
const mapDispatchToProps = dispatch => bindActionCreators({ uploadImage, sendReport }, dispatch)

export default injectIntl(compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('errors', 'setErrors', {}),
  withState('message', 'setMessage', ''),
  withState('success', 'setSuccess', null),
  withState('imagesState', 'setImages', {}),
  fetchingState(),
  withHandlers({
    upload: ({ setImages, uploadImage, lot, imagesState }) => e => {
      const files = e.target.files

      for (let i = 0; i < files.length; i++) {
        let file = files.item(i)

        imagesState[md5(file.name)] = 0
        setImages(imagesState)

        const onUpload = (e) => {
          imagesState[md5(file.name)] = Math.floor((e.loaded * 100) / e.total)
          setImages(imagesState)
        }

        uploadImage(lot._id, file, onUpload)
      }
    },
    imageRemove: ({ setImages, imagesState }) => (key, e) => {
      e && e.preventDefault()
      setImages(omit(imagesState, key))
    },
    setMessage: ({ setMessage }) => e => {
      const value = strip(e.target.value)
      setMessage(value)
    },
    submit: ({ images, imagesState, fetching, message, sendReport, fetchingWrap, lot, setErrors, setSuccess, onSuccess, intl }) => async e => {
      e && e.preventDefault()
      if (fetching) return

      let errors = {}
      if (!message || !message.length) errors.message = intl.formatMessage({id: 'profile_report.you_must_fill'})

      setErrors(errors)
      if (!isEmpty(errors)) return

      images = Object.values(pick(images, Object.keys(imagesState))).map(el => el._id)
      const result = await fetchingWrap(sendReport.bind(this, lot._id, message, images))
      setSuccess(result === 200)
      if (result === 200) onSuccess(lot._id)
    }
  }),
  lifecycle({
    componentWillUnmount () {
      this.props.setImages({})
    }
  })
)(ReportForm))



// WEBPACK FOOTER //
// ./src/components/Profile/Report.jsx